import { render, staticRenderFns } from "./askmanage.vue?vue&type=template&id=8bd88c20&scoped=true&"
import script from "./askmanage.vue?vue&type=script&lang=js&"
export * from "./askmanage.vue?vue&type=script&lang=js&"
import style0 from "./askmanage.vue?vue&type=style&index=0&id=8bd88c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd88c20",
  null
  
)

export default component.exports